/** Minimum pull distance (px) to trigger a refresh */
export const PULL_THRESHOLD = 80

/** Maximum visual translation distance (px) */
export const PULL_MAX_DISTANCE = 120

/** Height of the spinner indicator element (px) */
export const INDICATOR_HEIGHT = 48

/** Snap-back animation duration (ms) */
export const SNAP_BACK_DURATION = 300

/** Minimum time to show the refreshing state, prevents flash (ms) */
export const MIN_REFRESH_DURATION = 800

/** Resistance factor for rubber-band feel (0-1) */
export const PULL_RESISTANCE = 0.4

/** Easing curve for snap-back animation (iOS-like deceleration) */
export const SNAP_BACK_EASING = 'cubic-bezier(0.2, 0, 0, 1)'
